import React from 'react';
import Card from '../../../Card';
import Button from '../../Button';
import * as Style from './style';

export default () => (
	<Style.SpecialProjectContent>
		<Card title="Recebemos a sua solicitação!" classComponent="card-thank">
			Aguarde, que em breve entraremos em contato!
		</Card>
		<Button type="link" style={{ height: '40px', marginTop: '10px', fontSize: '12px' }} to="./campanhas">IR PARA A HOME</Button>
	</Style.SpecialProjectContent>
);
